import { useMemo } from 'react';
import { isEqual } from 'lodash/fp';
import { WithBillId, WithServiceId } from '@mews-commander/types';
import { OrderItem } from '@mews-commander/data-access';
import { useCommanderSelector } from '@mews-commander/utils';
import { getBillOrderItemsByServiceOrderId } from '../../../selectors';

interface UseServiceOrderItemsFlagsParams extends WithBillId, WithServiceId {
    serviceOrderId: string;
    month?: string;
}

export const useServiceOrderItemsFlags = ({
    billId,
    month,
    serviceId,
    serviceOrderId,
}: UseServiceOrderItemsFlagsParams) => {
    const orderItems = useCommanderSelector<OrderItem[]>(
        (state) =>
            // month is optional in getBillOrMonthOrderItems selector
            // @ts-expect-error Property 'month' is missing in type '{ billId: string; serviceId: string; serviceOrderId: string; }'
            getBillOrderItemsByServiceOrderId(state, { billId, month, serviceId, serviceOrderId }),
        isEqual
    );

    const areAllItemsReinstated = useMemo(() => orderItems.every((item) => item.isReinstated), [orderItems]);

    return { areAllItemsReinstated };
};
